import { Box } from "@mui/material";
import { ReactNode } from "react";

type Props = {
    children: ReactNode
}

const WizardContainer = ({ children }: Props) => {
    return (
        <Box sx={{ height: '100%' }}>
            {children}
        </Box>
    )
}

export default WizardContainer;